import { ScreenPaths } from '../constants/constants';
import { setScreen } from '../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../components/config/uiFactory.config';

const { MANAGEMENT, PURCHASE_HISTORY, TRANSACTION_REPORT, INTEGRATION_REPORT } = ScreenPaths;

/**
 * Throughout Dealer Portal, we attach a listener to the `popstate` event on
 * `Window` that examines the new path and commands the Redux-based navigation
 * system to show the appropriate page.
 * TODO: Replace this with something better, or at least only load it from
 *  one place in the application.
 *
 * @param dispatch The Redux store's `dispatch` function. Most of our components
 * get it using the react-redux `useDispatch` hook.
 */
export function addNavListener(dispatch) {
  window.addEventListener('popstate', function(e) {
    const path = e?.target?.location?.pathname?.replace(/\/$/, '');
    const pathPattern = /^\/dp\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})?$/;
    // The popstate event is fired each time when the current history entry changes.
    if (path === `/dp/${MANAGEMENT}`) {
      dispatch(setScreen({ screen: screens.SUBSCRIPTION_MANAGEMENT }));
    } else if (path === `/dp/${PURCHASE_HISTORY}`) {
      dispatch(setScreen({ screen: screens.DEALER_PURCHASE_REPORT }));
    } else if (path === `/dp/${TRANSACTION_REPORT}`) {
      dispatch(setScreen({ screen: screens.TRANSACTION_REPORT }));
    } else if (path === `/dp/${INTEGRATION_REPORT}`) {
      dispatch(setScreen({ screen: screens.INTEGRATION_REPORT }));
    } else if (pathPattern.test(path)){
      dispatch(setScreen({ screen: screens.STEPPER_CONTAINER }));
    }else {
      dispatch(setScreen({ screen: '' }));
    }
  }, false);
}
